import { API_URL } from "@/mainconfig";

const state = {
    cities: JSON.parse(sessionStorage.getItem("cities")) || [], // Simpan data kota di sessionStorage jika ada
    properties: JSON.parse(sessionStorage.getItem("properties")) || [], // Simpan data kota di sessionStorage jika ada

    error: null, // Untuk menyimpan error jika ada
    errorMessage: null, // Pesan error spesifik
    loading: false, // Status loading untuk operasi pengambilan data kota
};

const getters = {
    isLoading: (state) => state.loading, // Apakah dalam status loading
    getCities: (state) => state.cities, // Data kota
    getProperties: (state) => state.properties, // Data kota
    getPropertiesConvert: (state) =>
        state.properties.map((property) => ({
            label: property.Name,
            value: property.Id,
        })),
    getCityError: (state) => state.errorMessage, // Pesan error pengambilan data kota
};

const actions = {
    async fetchCities({ commit }) {
        commit("setLoading", true); // Aktifkan loading state
        try {
            const response = await API_URL.get("/city/getAll"); // Panggil endpoint /city/getAll

            // console.log("API Response (Cities):", response.data); // Debug: Cetak response dari backend

            const cities = response.data?.data || []; // Cek apakah `data` ada di response
            commit("setCities", cities); // Set data kota ke state
            commit("setError", null); // Bersihkan error jika sukses

            return cities; // Kembalikan data kota
        } catch (error) {
            // console.error("Error fetching cities:", error.response?.data || error.message); // Debug: Log error
            commit(
                "setError",
                error.response?.data?.msg || "Failed to fetch cities."
            );
            throw error;
        } finally {
            commit("setLoading", false); // Nonaktifkan loading state
        }
    },

    async fetchProperties({ commit }) {
        commit("setLoading", true); // Aktifkan loading state
        try {
            const response = await API_URL.get("/property-type/getAllType"); // Panggil endpoint /city/getAll
            // console.log("API Response (Cities):", response.data); // Debug: Cetak response dari backend

            const properties = response.data?.data || []; // Cek apakah `data` ada di response
            commit("setProperties", properties); // Set data kota ke state
            commit("setError", null); // Bersihkan error jika sukses

            return properties; // Kembalikan data kota
        } catch (error) {
            // console.error("Error fetching cities:", error.response?.data || error.message); // Debug: Log error
            commit(
                "setError",
                error.response?.data?.msg || "Failed to fetch cities."
            );
            throw error;
        } finally {
            commit("setLoading", false); // Nonaktifkan loading state
        }
    },

    clearCities({ commit }) {
        // Bersihkan data kota dari state dan sessionStorage
        commit("clearCities");
    },
};

const mutations = {
    setProperties(state, properties) {
        // Set data kota ke state dan simpan ke sessionStorage
        state.properties = properties;
        sessionStorage.setItem("properties", JSON.stringify(properties));
    },
    clearProperties(state) {
        // Hapus data kota dari state dan sessionStorage
        state.properties = [];
        sessionStorage.removeItem("properties");
    },
    setCities(state, cities) {
        // Set data kota ke state dan simpan ke sessionStorage
        state.cities = cities;
        sessionStorage.setItem("cities", JSON.stringify(cities));
    },
    clearCities(state) {
        // Hapus data kota dari state dan sessionStorage
        state.cities = [];
        sessionStorage.removeItem("cities");
    },
    setLoading(state, loading) {
        // Set status loading
        state.loading = loading;
    },
    setError(state, error) {
        // Set error jika terjadi masalah
        state.error = error;
        state.errorMessage = error || "An error occurred.";
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
